module.exports = __webpack_public_path__ + "static/media/arrow-to-right.055e8a5e.svg";